import { forwardRef } from "react";
import type { EquiplyIconProps, EquiplyIcon } from "../types";

/** Prime panier repas IDCC 1505 — assiette + couverts duotone */
export const MealBreakIcon: EquiplyIcon = forwardRef<SVGSVGElement, EquiplyIconProps>(
  ({ size = 24, ...props }, ref) => (
    <svg ref={ref} width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      {/* Assiette menthe */}
      <circle cx="12" cy="14" r="6.5" fill="var(--equiply-icon-bg)" />
      <circle cx="12" cy="14" r="4" fill="hsl(var(--background))" />
      {/* Fourchette gauche */}
      <path
        d="M5 3v6c0 .55.45 1 1 1s1-.45 1-1V3M6 10v11"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinecap="round"
      />
      {/* Couteau droit */}
      <path
        d="M18 3c-1.5 1-2 3-2 5s.5 3 2 3v10"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"
      />
    </svg>
  ),
);
MealBreakIcon.displayName = "MealBreakIcon";
